import React from 'react';
import { Countdown } from './Countdown';
export function Urgency() {
  return <section className="w-full bg-pine" data-id="element-294" data-mp="2bwe6imbbrd3g">
      <div className="mx-auto max-w-3xl px-5 py-12 text-center sm:py-16" data-id="element-295" data-mp="2bvcvuiy80sm9">
        <p className="eyebrow text-ember" data-id="element-296" data-mp="1wzwzg7a64kmp">Limited-time offer</p>
        <h2 className="mt-3 font-display text-2xl text-paper sm:text-4xl" data-id="element-297" data-mp="1x1rgvbm8dum1">
          The launch price ends in:
        </h2>
        <div className="mt-6" data-id="element-298" data-mp="1o7d1za5m4m3g">
          <Countdown tone="dark" data-id="element-299" data-mp="1o6bhyg6mcp9l" />
        </div>
        <p className="mt-5 text-sm text-paper/75" data-id="element-300" data-mp="1sxti520tilti">
          After that the price goes up by{' '}
          <span className="font-bold text-ember" data-id="element-301" data-mp="1e8xdlexyzqxn">$42</span> and stays there.
        </p>
      </div>
    </section>;
}